<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ClaimApi from "@/services/claim-api";

export default {
  page: {
    title: "Reclamations & Suggestions",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mounted(){
      
      this.role=sessionStorage.getItem("userr");
      this.getClaims();

  },

  components: { Layout },
  data() {
    return {

      claimsListFields: [
        
          { key:"timestampStr", label: "Date", sortable: false, tdClass:""},
          { key:"subject", label: "Objet", sortable: false, tdClass:""},
          
          { key:"customer", label: "Client",thClass:"",tdClass:""},
          { key:"user", label: "Utilisateur",thClass:"",tdClass:""},

          { key:"lastModifTimestampStr", label: "Dernière Modification", sortable: false, tdClass:""},
          { key:"status", label: "Etat",  thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},

          { key:"actions", label: "Ouvrir",thClass:"text-center",tdClass:"text-center"},
        ],

        role: null,

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
        claimsList: [],
        isTableLoading: false,

        subject: null,
        message: null,


        showClaimModal: false,
        selectedClaim: {customer:null,},
     
    };
  },
  methods: {

      addClaim() {
        ClaimApi.addClaim(this.subject, this.message).then(
          ()=>{
            this.getClaims();
            this.subject = null;
            this.message = null;
          }
        )
      },

      changeStatus(status) {

        if (this.selectedClaim == null) {
          return;
        }

        ClaimApi.changeStatus(this.selectedClaim.id, status).then(
          (result)=>{
            if (result) {
              this.showClaimModal = false;
            }
            this.getClaims();
          }
        )
      },

      getClaims() {
        this.isTableLoading = true;
        ClaimApi.getClaims(this.pagemodel.currentPage, this.pagemodel.perPage).then(
            result => {
              this.claimsList = result.list
              this.pagemodel.totalRows = result.total;
              this.pagemodel.currentPage = result.page;
              this.pagemodel.perPage = result.pageSize;
              this.pagemodel.pageSize = result.pageSize;
          })
          .finally(() => {
            this.isTableLoading = false;
        })
      },

      showClaim(item) {
        if (item == null) {
          return;
        }
        
        this.selectedClaim = item; 
        this.showClaimModal=true;
      }
      


  },
    

  watch : {

    /*selectedMonth : function() {
          this.mform.month = this.selectedMonth;
          this.mform.onCallWeek = null;
    },

    selectedYear : function() {
          this.mform.year = this.selectedYear;
          this.mform.onCallWeek = null;
    },*/
    
  }

  
};
</script>

<style>

</style>

<template>
  <Layout>

    <div v-if="role == 0" class="row pb-4  pt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="row">

              <div class="col-md-8 col-sm-12">
                  <h3 class="card-title " style="font-size:1.5em;">Nouvelle Réclamation ou Suggestion</h3>
              </div>


            </div>

            <div class="row pt-4"> 
                <div class="col-sm-2 col-xs-0"/>

                <div class="col-sm-8 col-xs-12">
                    <b-form-group label="Objet" label-for="">
                          <b-form-input v-model="subject" :maxlength="50" class="form-control font-size-16"/>
                    </b-form-group>
                </div>

            </div> 

            <div class="row pt-2"> 
                <div class="col-2 col-xs-0"/>

                <div class="col-sm-8 col-xs-12">
                    <b-form-group label="Message" label-for="">
                      <textarea
                          v-model="message"
                          class="form-control"
                          :maxlength="3000"
                          rows="10"
                          placeholder="Ajouter votre réclamation ou suggestion"
                      />
                    </b-form-group>
                </div>

            </div> 

            <div class="row pt-3"> 
                <div class="col-7 col-xs-0"/>

                <div class="col-sm-3 col-xs-12">
                    <b-button variant="danger" class="w-100 font-weight-bold " @click="addClaim()">
                        <i class="fas fa-paper-plane align-middle mr-2 ml-2" /> Envoyer
                    </b-button>
                </div>



                

            </div> 

          </div>
        </div>
      </div>
    </div>  
    
    <div class="row pb-4 pt-4">
      <div class="col-lg-12">
        <div class="card border border-light">
          <div class="card-body" >

            <div class="row">

              <div class="col-md-8 col-sm-12">
                  <h3 class="card-title text-primary" style="font-size:1.5em;">Liste des Réclamations & Suggestions</h3>
              </div>


            </div>

            <div class="row pt-4" style="min-height:450px;"> 
               
                <div class="col-sm-12 col-xs-12 pr-3">

                  <div class="table-responsive">
                  <b-table 
                    :busy="isTableLoading"
                    :striped="true"

                    :small="false"
                    :hover="true"

                    :items="claimsList"
                    :fields="claimsListFields"

                    :perPage="pagemodel.perPage"
                    class="table  ">

                        <template v-slot:table-busy>
                          <div class="text-center my-2">
                              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                          </div>
                        </template>

                        <template v-slot:cell(status)="{value}">
                          <h5><b-badge href="#" :variant="value == 0 ? 'danger' : value == 1 ? 'warning' : 'light'">{{value == 0 ? 'Nouvelle' : value == 1 ? 'En cours' : 'Cloturée'}}</b-badge></h5>
                        </template>

                        <template v-slot:cell(actions)="{item}">
                          <!-- <b-button variant="outline-success" class="font-weight-bold " @click="showClaim(item)"> -->
                              <i class="mdi mdi-comment-text-multiple-outline font-size-18 font-weight-bold text-primary align-middle" @click="showClaim(item)" style="cursor: pointer;" />
                          <!-- </b-button> -->
                        </template>

                        <template v-slot:cell(timestampStr)="{value, item}">
                          <span :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value }}</span>
                        </template>

                        <template v-slot:cell(lastModifTimestampStr)="{value, item}">
                          <span :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value ? value : '-' }}</span>
                        </template>

                        <template v-slot:cell(subject)="{value, item}">
                          <span :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value }}</span>
                        </template>

                        <template v-slot:cell(customer)="{value, item}">
                          <span :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value }}</span>
                        </template>

                        <template v-slot:cell(user)="{value, item}">
                          <span :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value }}</span>
                        </template>


                    </b-table>
                  </div>
                    
                    <span v-if="!isTableLoading && !claimsList.length" 
                    class="d-flex justify-content-center m-4 text-danger" >Aucune réclamation ou suggestion</span>
                  
                  

                </div>

            </div> 

             <!-- Pagination -->
        <div class="row pt-3 ">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getClaims()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodel.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :disabled="isTableLoading" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getClaims()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->


          </div>
        </div>
      </div>
    </div>  

    <b-modal v-model="showClaimModal" 
        :title="'Réclamation ' + this.selectedClaim.customer + ' du ' + this.selectedClaim.timestampStr"    
        hide-footer 
        centered 
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        size="lg">


            <div class="row pt-2"> 
                
                <div class="col-12">
                  <b-form-group label="Objet" label-for="">
                          <b-form-input v-model="selectedClaim.subject" :maxlength="50" disabled class="form-control font-size-16"/>
                    </b-form-group>
                </div>
            </div>

            <div class="row pt-2"> 

                <div class="col-12">
                    <b-form-group label="Message" label-for="">
                      <textarea
                          v-model="selectedClaim.message"
                          class="form-control"
                          :maxlength="3000"
                          rows="10" disabled
                          placeholder="Ajouter votre réclamation ou suggestion"
                      />
                    </b-form-group>
                </div>

            </div> 

            <div v-if="role == 2" class="row pt-2"> 

              

              <div  class="col-sm-4 col-xs-12 p-2">
                <b-button variant="warning" class="w-100 font-weight-bold " :disabled="selectedClaim.status == 1" @click="changeStatus(1)">
                        <i class="fas fa-history align-middle font-size-16 mr-2 ml-2" /> En cours
                    </b-button>
              </div>

              <div  class="col-sm-4 col-xs-0"/>

              <div class="col-sm-4 col-xs-12 p-2">
                  <b-button variant="success" class="w-100 font-weight-bold " :disabled="selectedClaim.status == 2"  @click="changeStatus(2)">
                      <i class="fas fa-check-circle align-middle font-size-16 mr-2 ml-2" /> Cloturer
                  </b-button>
              </div>

            </div>

            <div v-if="role == 0" class="row pt-2"> 

                <div class="col-sm-8 col-xs-0"/>

                <div class="col-sm-4 col-xs-12 p-2">
                    <b-button variant="secondary" class="w-100 font-weight-bold " :disabled="selectedClaim.status == 2" @click="changeStatus(2)">
                        <i class="fas fa-times-circle align-middle font-size-16 mr-2 ml-2" /> Annuler
                    </b-button>
                </div>

            </div>

            
      </b-modal>

  </Layout>
</template>